import type { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const warehouseRoutes: PermissionedRouteObject[] = [
  {
    index: true,
    handle: { breadcrumb: "Warehouse Management" },
    async lazy() {
      const { WarehouseLandingPage } = await import(
        "@redotech/redo-merchant-fulfillment-app/warehouse-landing-page"
      );
      return { Component: WarehouseLandingPage };
    },
  },
  {
    path: "transfer",
    handle: { breadcrumb: "Transfer" },
    async lazy() {
      const { TransferLayout } = await import(
        "@redotech/redo-merchant-fulfillment-app/transfer/transfer-layout"
      );
      return { Component: TransferLayout };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { TransferPage } = await import(
            "@redotech/redo-merchant-fulfillment-app/transfer/transfer-page"
          );
          return { Component: TransferPage };
        },
      },
      {
        path: "items",
        handle: { breadcrumb: "Select Items" },
        async lazy() {
          const { TransferItemsPage } = await import(
            "@redotech/redo-merchant-fulfillment-app/transfer/transfer-items-page"
          );
          return { Component: TransferItemsPage };
        },
      },
      {
        path: "lost-items",
        handle: { breadcrumb: "Find Items" },
        async lazy() {
          const { TransferLostItemsPage } = await import(
            "@redotech/redo-merchant-fulfillment-app/transfer/transfer-lost-items-page"
          );
          return { Component: TransferLostItemsPage };
        },
      },
      {
        path: "route",
        handle: { breadcrumb: "Transfer Route" },
        async lazy() {
          const { TransferRoutePage } = await import(
            "@redotech/redo-merchant-fulfillment-app/transfer/transfer-route-page"
          );
          return { Component: TransferRoutePage };
        },
      },
    ],
  },
];
